import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PlansView, CarriersView, BcbsView } from './Items';
import styled from 'styled-components';
import { breakpoint } from '../../../grid';
import { getDropdownState } from '../../data/dropdown-state';
import { TAB } from '../../constants';

export class InsuranceInfoPickerView extends Component {
    render() {
        const {
            tab,
            canSeeBcbs,
            headerVisible,
        } = this.props;

        // postion determines which panel the picker view is currently displaying
        const POSITION_1 = '0';
        const POSITION_2 = '-1';
        const POSITION_3 = '-2';

        let position = POSITION_1;
        if ((tab === TAB.PLAN && !canSeeBcbs) || (tab === TAB.BCBS && canSeeBcbs)) {
            position = POSITION_2;
        } else if (tab === TAB.PLAN && canSeeBcbs) {
            position = POSITION_3;
        }
        return (
            <ShiftingPanels
                carrierHeader={headerVisible}
                position={position}
            >
                <Panel>{this.renderFirstPanel(position === POSITION_1)}</Panel>
                <Panel>{this.renderSecondPanel(position === POSITION_2)}</Panel>
                <Panel>{this.renderThirdPanel(position === POSITION_3)}</Panel>
            </ShiftingPanels>
        );
    }

    renderFirstPanel = active => {
        return (
            <CarriersView active={active} />
        );
    }

    renderSecondPanel = active => {
        const { canSeeBcbs } = this.props;

        if (!canSeeBcbs) {
            return (<PlansView active={active} />);
        } else {
            return (<BcbsView active={active} />);
        }
    }

    renderThirdPanel(active) {
        const { canSeeBcbs } = this.props;

        if (canSeeBcbs) {
            return (<PlansView active={active} />);
        } else {
            return null;
        }
    }
}

const ShiftingPanels = styled.div`
    transition: transform 500ms ease-in-out;
    display: flex;
    height: auto;
    width: 300vw;
    transform: translateX(${p => p.position * 100}vw);

    ${breakpoint.small} {
        height: ${p => p.carrierHeader ? '420px' : '456px'};
        width: 300%;
        transform: translateX(${p => p.position * (100 / 3)}%);
    }
`;

const Panel = styled.div`
    vertical-align: top;
    height: 100%;
    width: 100%;
`;

export function mapStateToProps(state) {
    const dropdownState = getDropdownState(state);

    return {
        tab: dropdownState.tab,
        canSeeBcbs: dropdownState.canSeeBcbs,
        headerVisible: !!dropdownState.carrier,
    };
}

export default connect(mapStateToProps, undefined)(InsuranceInfoPickerView);
